﻿import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { signinUrl } from '../../api/auth';
import './LoginPage.css';

type FromLocation = { pathname?: string; search?: string; hash?: string };

function loginReturnPath(state: unknown): string {
  const fromLoc = (state as { from?: FromLocation } | null)?.from;
  return fromLoc?.pathname
    ? `${fromLoc.pathname}${fromLoc.search ?? ''}${fromLoc.hash ?? ''}`
    : '/';
}

export function LoginPage() {
  const location = useLocation();
  const from = loginReturnPath(location.state);

  useEffect(() => {
    window.location.assign(signinUrl(from));
  }, [from]);

  function handleSignIn() {
    window.location.assign(signinUrl(from));
  }

  return (
    <div className="login-root">
      <header className="login-brand-header">
        <div className="login-brand-inner">
          <a className="login-brand-link" href="/" aria-label="Go to home">
            <div className="login-brand-logo-wrap">
              <img
                src="/img/assistant-logo.webp"
                alt="JARVIS IT Assistant logo"
                className="login-brand-logo"
              />
            </div>
            <div className="login-brand-text">
              <h1>JARVIS IT Assistant</h1>
              <p className="login-brand-tagline">
                Personalized digital IT assistant always there to help.
              </p>
            </div>
          </a>
        </div>
      </header>

      <main className="login-main">
        <div className="login-section">
          <div className="login-card">
            <h2 className="login-card-title">Sign in</h2>
            <p className="login-card-lead">
              Please sign in with your Microsoft work or school account to continue.
            </p>
            {/* Plain HTML — DevExtreme Button on first paint can hit React #185 under React 19. */}
            <button type="button" className="login-signin-btn" onClick={handleSignIn}>
              <i className="dx-icon dx-icon-user" aria-hidden />
              Sign in with Microsoft
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
